// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---wvPIN","changedRecordsList":"changedRecordsList---P1LOR","changedRecord":"changedRecord---ptnS7"};